<template>
  <div class="nkn-miner">
    <div>
      <div class="nkn-container">
        <miner-intro></miner-intro>
      </div>
      <!--<div class="nkn-container">
        <miner-get-started></miner-get-started>
      </div>-->
      <div class="nkn-container">
        <miner-node-software></miner-node-software>
      </div>
      <div class="nkn-container">
        <miner-resources></miner-resources>
      </div>
    </div>
  </div>
</template>

<script>
import MinerIntro from '@/components/miner/nknMiningIntro'
import MinerGetStarted from '@/components/miner/nknGetStarted'
import MinerNodeSoftware from '@/components/miner/nknNodeSoftware'
import MinerResources from '@/components/miner/nknMiningResources'
export default {
  components: {
    MinerIntro, MinerGetStarted, MinerNodeSoftware, MinerResources
  },
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: '节点共建者门户',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: '节点共建者入门介绍，常见问答，软件下载。'
          }
        ]
      }
    } else {
      return {
        title: 'Miner Portal | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'Interested in mining through the NKN network? Click here to find the necessary mining tools and resources you need to start mining tokens.'
          }
        ]
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.nkn-miner{
  /*padding: 6rem 0 5rem 0;*/
}
.nkn-container:nth-child(even) {
  background-color: #f9faff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/MinerPortal.vue